import { createRouter, createWebHistory, RouteRecordRaw,RouteLocationNormalized } from 'vue-router'
import routerBefore from './routerBefore'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'Layout',
    component: () => import('@/layout/index.vue'),
    children: [
      {
        path: '',
        name: 'Root',
        redirect: '/dataDashboard'
      },
      {
        path: '/dataDashboard',
        name: 'DataDashboard',
        component: () => import('@/views/main/Index.vue'),
        meta: { title: '首页', requiresAuth: true, keepAlive: true, icon: 'home' }
      },
      {
        path: '/order',
        name: 'Order',
        meta: { title: '订单管理', requiresAuth: true, keepAlive: true, icon: 'setting' },
        children: [
          {
            path: '/order/orderList',
            name: 'OrderList',
            component: () => import('@/views/order/orderList/Index.vue'),
            meta: { title: '业务员综合账单', requiresAuth: true, keepAlive: true }
          }
        ]
      },
      {
        path: '/setting',
        name: 'Setting',
        meta: { title: '设置', requiresAuth: true, keepAlive: true, icon: 'setting' },
        children: [
          {
            path: '/setting/personalInfo',
            name: 'PersonalInfo',
            component: () => import('@/views/setting/personalInfo/Index.vue'),
            meta: { title: '个人信息', requiresAuth: true, keepAlive: true }
          },
          {
            path: '/setting/resetPassword',
            name: 'ResetPassword',
            component: () => import('@/views/setting/resetPassword/Index.vue'),
            meta: { title: '修改密码', requiresAuth: true, keepAlive: true }
          },
        ]
      },
      {
        path: '/notFound',
        name: 'LayoutNotFound',  // 修改名称，避免重复
        component: () => import('@/views/base-page/404/Index.vue'),
        meta: { title: '404', requiresAuth: false, keepAlive: true }
      },
      {
        path: '/noAuth',
        name: 'NoAuth',
        component: () => import('@/views/base-page/403/Index.vue'),
        meta: { title: '403', requiresAuth: false, keepAlive: true }
      }
    ]
  },
  {
    path: '/home',
    name: 'Home1',
    component: () => import('@/views/home/Index.vue'),
    meta: { title: 'home', requiresAuth: false, keepAlive: false }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/Index.vue'),
    meta: { title: '登录', requiresAuth: false, keepAlive: false }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/noPermission/register/Index.vue'),
    meta: { title: '注册', requiresAuth: false, keepAlive: false }
  },
  {
    path: '/reviewProgress',
    name: 'ReviewProgress',
    component: () => import('@/views/noPermission/reviewProgress/Index.vue'),
    meta: { title: '注册进度', requiresAuth: false, keepAlive: false }
  },
  {
    path: '/forgetPwd',
    name: 'ForgetPwd',
    component: () => import('@/views/noPermission/forgetPwd/Index.vue'),
    meta: { title: '忘记密码', requiresAuth: false, keepAlive: false }
  },
  // 添加404页面路由
  {
    path: '/error/404',  // 修改路径，避免与嵌套路由冲突
    name: 'GlobalNotFound',  // 修改名称，避免重复
    component: () => import('@/views/error/404.vue'),
    meta: { title: '页面不存在', requiresAuth: false, keepAlive: false }
  },
  // 修正通配符路由
  {
    path: '/:pathMatch(.*)*',
    name: 'CatchAll',  // 修改名称，避免重复
    redirect: '/error/404'  // 修改重定向路径
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 移除afterEach钩子，如果不需要的话
// router.afterEach((to, from) => {})

// 路由导航
routerBefore(router)
export default router
